import { FETCH_RISK_SCORE_CHARGES_SUCCESS, FETCH_RISK_SCORE_CHARGES_REQUEST, FETCH_RISK_SCORE_CHARGES_FAILURE, } from "@/redux/actions";
const initialState = {
    data: null,
    loading: false,
    error: null,
};
const getRiskScoreChargesReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_RISK_SCORE_CHARGES_SUCCESS:
            return Object.assign(Object.assign({}, state), { loading: false, error: null, data: action.payload });
        case FETCH_RISK_SCORE_CHARGES_REQUEST:
            return Object.assign({}, state);
        case FETCH_RISK_SCORE_CHARGES_FAILURE:
            return Object.assign(Object.assign({}, state), { loading: false, error: action.payload });
        default:
            return state;
    }
};
export default getRiskScoreChargesReducer;
